/**
 * Страницы, которые должны быть добавлены в SiteMap
 * комментарии [START-PARSE] и [END-PARSE]
 * нужны скрипту по созданию путей рендеров.
 * Они указывают где начинать и где заканчивать брать пути для формирования рендеров
 * Внутренние комментарии // пропускаются скриптом
 * Скрипты сидят тут: \fast-angular\scripts
 */
export const seoRoutes: string[] = [
  /*[[START-PARSE]]*/
  '/',
  '/about',
  '/faq',
  '/tos',
  '/reviews',
  '/privacy-policy',
  '/cookie-policy',
  '/responsible-play-policy',
  '/fair-play-policy',
  '/credits-policy',
  '/items-use-policy',
  '/game/cases',
  '/game/case-battle',
  '/game/upgrader',
  '/game/tickets',
  '/store',
  '/tickets',
  '/fifa',
  '/events/odyssey-infinite',
  '/bug-bounty',
  '/bonuses/referral',
  '/refund-policy',
  '/account/referral/campaigns',
  '/account/main',
  '/login',
  '/partnership',
  /*[[END-PARSE]]*/
];
